import cx from 'clsx';
import type { ReactNode } from 'react';
import { Type } from 'src/components/core';
import { appConfig } from 'src/config';
import type { BlogPage } from '../../types/blogPage';
import { DocumentMetadata } from './metadata.component';

export interface DocumentHeaderProps {
  className?: string;
  document: BlogPage;

  /**
   * @default Brand.AppName
   */
  subtitle?: ReactNode;
}

export function DocumentHeader({
  className,
  document,
  subtitle = appConfig.brand.appName,
}: DocumentHeaderProps) {
  const subtitleText = subtitle?.toString();
  return (
    <div className={cx(className)}>
      <Type
        bold
        component="h1"
        variant={['text-3xl', 'sm:text-4xl']}
        className="mb-3.5 text-center sm:mb-5"
      >
        {document?.attributes?.title}
      </Type>
      <Type
        component="h2"
        colorVariant="faded"
        weight="font-medium"
        variant={['text-lg', 'sm:text-xl']}
        className="mb-2 text-center"
      >
        {subtitleText}
      </Type>
      <DocumentMetadata
        document={document}
        containerClassName="justify-center"
      />
    </div>
  );
}
